// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Component
export default defineComponent({
    // #region Class
    name: 'g-ozg-service-page',
    // #endregion
    // #region Properties
    data: () => ({
        process: {},
        schema: {},
        data: {},
        servicePage: {},
        errorMessage: [],
    }),
    computed: {
        masterID() {
            return this.$route.params.master;
        },
        processId() {
            return this.$route.params.process;
        },
        pages() {
            return this?.schema?.pages ?? [];
        },
        allMessages() {
            if (!this.servicePage) {
                return [];
            }
            return forms.getAllErrorMessages(this.schema, this.servicePage, this.errorMessage);
        },
        allPages() {
            let tPages = [];
            {
                this.$forms.getAllPages(tPages, this.schema.pages ?? []);
            }
            return tPages;
        }
    },
    // #endregion
    // #region Constructor
    async created() {
        this.load();
    },
    // #endregion
    // #region Methods
    methods: {
        async load() {
            // #region Load
            let tData = await this.$host.api.get('/forms/processes/' + this.masterID + '/sub/' + this.processId, { params: { mode: 'service' } });
            // #endregion
            // #region Vars
            if (tData.data) {
                this.schema = tData.data ?? {};
                this.process = tData.data ?? {};
                this.data = tData?.data?.data ?? {};
            }
            // #endregion
            // #region Page
            this.servicePage = this.pages.length === 0 ? null : this.pages[0];
            this.calculate();
            // #endregion
        },
        calculate() {
            // #region Schema
            this.schema.allPages = forms.getAllPagesAsObject(this.pages);
            // #endregion
            this.allPages.forEach(e => {
                // #region Fields
                if (e.content) {
                    //Data
                    let tPageData = this.$forms.getDataForEval(this.schema, this.data, e);
                    //Run
                    e.content.forEach((el) => {
                        el.isVisible = this.$forms.isVisible(el, tPageData);
                    });
                }
                // #endregion
            });
        }
    }
    // #endregion
});
// #endregion
